import { ArrowRight } from 'lucide-react'
import { Button } from '@insightai/ui'
import { Link } from 'react-router-dom'
import { FeatureShowcase } from '../components/FeatureShowcase'
import { Hero } from '../components/Hero'
import { PersonaCards } from '../components/PersonaCards'
import { UspCards } from '../components/UspCards'

/** MOD-00 landing page — primary page 1 of the 15 audited for AC-56. */
export function HomePage() {
  return (
    <>
      <Hero />
      <UspCards />
      <PersonaCards />
      <FeatureShowcase />

      <section className="border-t border-border-subtle bg-surface-raised">
        <div className="mx-auto flex max-w-3xl flex-col items-center gap-5 px-4 py-16 text-center sm:px-6">
          <h2 className="text-h1">Start with the question you actually have</h2>
          <p className="text-body text-text-secondary">
            No methodology expertise needed. You will see the cost range and the proposed design
            before anything is commissioned.
          </p>
          <Button size="lg" asChild iconEnd={<ArrowRight aria-hidden className="size-4" />}>
            <Link to="/auth/signup">Start Free Brief</Link>
          </Button>
        </div>
      </section>
    </>
  )
}
